import React, { useState, useContext, useEffect } from 'react'
import {
  DatePicker,
  Table,
  Button,
  Input,
  Modal,
  Icon,
  Popconfirm,
  message,
} from 'antd'
import {
  deletKindleDataImportLog,
  getKindleDataImportLog,
  getKindleLogBlob,
} from 'api/pgads'
import { connect } from 'react-redux'
import moment from 'moment'
import { getApiTargetInfo } from 'core'
import { ErrorContext, DatePickerContext, SpinContext } from 'context'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
const Column = getBlobTask => [
  {
    title: 'Trans ID',
    dataIndex: 'uuid',
    width: 280,
  },
  {
    title: 'Service Name',
    dataIndex: 'importType',
    width: 150,
  },

  {
    title: 'Import Start Time',
    dataIndex: 'importStartTime',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  },

  {
    title: 'Import End Time',
    dataIndex: 'importEndTime',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  },
  {
    title: 'Data Req. Start Time',
    dataIndex: 'requestStartDate',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY'),
  },

  {
    title: 'Data Req. End Time',
    dataIndex: 'requestEndDate',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY'),
  },
  {
    title: 'Status',
    dataIndex: 'importStatus',
    width: 100,
  },

  {
    title: 'Request',
    dataIndex: 'requestData',
    width: 70,
    render: text => (
      <span>
        <Icon
          style={{ marginRight: `5px`, cursor: `pointer` }}
          theme="twoTone"
          type={
            text !== undefined && text.startsWith('1:') ? 'file-text' : 'file'
          }
          onClick={() => getBlobTask(text.substring(2), 'request_Data')}
          key="request_blob"
        />
        {text !== undefined && text.startsWith('1:') ? 'BLOB' : 'N/A'}
      </span>
    ),
  },
  {
    title: 'Message',
    dataIndex: 'message',
    width: 80,
    render: text => (
      <span>
        <Icon
          style={{ marginRight: `5px`, cursor: `pointer` }}
          theme="twoTone"
          type={
            text !== undefined && text.startsWith('1:') ? 'file-text' : 'file'
          }
          onClick={() => {
            if (text !== undefined && text.startsWith('1:'))
              getBlobTask(text.substring(2), 'message')
            else message.info('Empty BLOB')
          }}
          key="responseBlob"
        />
        {text !== undefined && text.startsWith('1:') ? 'BLOB' : 'N/A'}
      </span>
    ),
  },
]

const KindleDataImportLog = props => {
  const targetInfo = props.targetInfo
  const [data, setData] = useState(null)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)

  useEffect(_ => setData([]), [selectedDate, setSelectedDate])
  const [modal, setModal] = useState(false)
  const [blob, setBlob] = useState(null)

  const [filter, setFilter] = useState('')
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const retrieveTask = ({ date = selectedDate }) => {
    setSpinning(true)

    getKindleDataImportLog(targetInfo)(date).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const getBlobTask = (transId, type) => {
    getKindleLogBlob(targetInfo)({ transId, type }).fork(setError, res => {
      setModal(true)
      setBlob(res)
    })
  }

  const filteredData = (data, filterText) => {
    return (
      data &&
      data.filter(d => {
        if (filterText.trim().length <= 0) return true
        return (
          (d.importType &&
            d.importType.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.uuid && d.uuid.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.importStatus &&
            d.importStatus.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.importStartTime &&
            moment(d.importStartTime)
              .format('MM/DD/YYYY HH:mm:ss')
              .toLowerCase()
              .includes(filterText.toLowerCase()))
        )
        // (d.serviceName && d.serviceName.startsWith(filterText)) ||
        // (d.transId && d.transId.includes(filterText))
      })
    )
  }
  const confirm = _ => {
    setSpinning(true)
    deletKindleDataImportLog(targetInfo).fork(setError, _ => {
      setSpinning(false)
      message.info('Log Deleted.')
    })
  }

  return (
    <div>
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Data Import Logs
        </Title>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />
        <Button
          style={{ marginLeft: '10px' }}
          type="primary"
          onClick={_ => retrieveTask({})}
        >
          Retrieve
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          style={{ marginLeft: '10px', width: 200 }}
          onChange={e => setFilter(e.target.value)}
        />
        <Popconfirm
          title={
            <div>
              <div>Are you sure delete this task?</div>
              <div>
                This will delete log which has Transaction Date lower than 3
                months ago.
              </div>
            </div>
          }
          onConfirm={confirm}
          // onCancel={cancel}
          okText="Confirm"
          cancelText="Cancel"
        >
          <Button type="danger" style={{ marginLeft: 20, marginRight: '50px' }}>
            Delete LOG
          </Button>
        </Popconfirm>
        <Modal
          maskClosable
          title="File"
          visible={modal}
          onOk={() => setModal(false)}
          onCancel={() => setModal(false)}
          destroyOnClose
          closable
          footer={
            <Button type="primary" onClick={() => setModal(false)}>
              OK
            </Button>
          }
        >
          <div
            style={{
              maxHeight: '400px',
              display: 'grid',
              gridTemplateColumns: '1fr',
              overflowX: 'auto',
            }}
          >
            <Input.TextArea autosize value={blob} />
          </div>
        </Modal>
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height }) => (
          <Content style={{ height, padding: '10px' }}>
            <div>
              <Table
                className="tableifw"
                columns={Column(getBlobTask)}
                dataSource={filteredData(data, filter)}
                bordered
                pagination={false}
                scroll={{ y: height - 50 }}
                // scroll={{ x: true, y: true }}
                size="small"
                rowKey={e => e.uuid}
              />
            </div>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(KindleDataImportLog)
